import * as types from './mutation-types';

export default {
  [types.SET_POPUP](state, { popupType, popupResolve, popupReject, popupData }) {
    state.popupType = popupType;
    state.popupResolve = popupResolve;
    state.popupReject = popupReject;
    state.popupData = popupData;
  },
  [types.RESET_POPUP](state) {
    state.popupType = null;
    state.popupResolve = null;
    state.popupReject = null;
    state.popupData = null;
  },
};
